export enum CartModes {
  snipcart = 'snipcart',
  drupal = 'drupal',
  drupalExternal = 'drupal_external'
}

export type CartMode = CartModes.snipcart | CartModes.drupal | CartModes.drupalExternal;
